import React from 'react';
import * as Styles from './AiAgentsHighlight.styles';
import { useResize } from '@/hooks/useResize';
import {
  DivContents,
  DivImg,
  WrapperTitle,
  DivText,
  ButtonWrapper,
} from '../Highlight.styles';
import { IconAiStar, Tag } from 'gatorcomponents';
import GradientButton from '@/components/Buttons/GradientButton';

const AiAgentsHighlight = ({
  element,
  buttonIsLoading = false,
}) => {
  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;

  return (
    <DivContents id={element.id} key={element.id} data-testid={`highlight-${element.id}`}>
      <DivImg>
        <img
          src={element.image}
          alt="produto em destaque"
        />
      </DivImg>

      <DivText>
        {element.badge && (
          <Styles.BadgeWrapper>
            <Tag label={element.badge} rounded={false} variant="active" />
          </Styles.BadgeWrapper>
        )}
        <Styles.WrapperSubtitle>
          <Styles.Subtitle data-testid={`subtitle-${element.id}`}>{element.subtitle}</Styles.Subtitle>
          <IconAiStar
            gradient="tertiary"
            size="md"
            testId="myIconTestId"
          />
        </Styles.WrapperSubtitle>


        <WrapperTitle>
          <Styles.Title data-testid={`title-${element.id}`}>{element.title}</Styles.Title>
        </WrapperTitle>

        <Styles.DescriptionList>
          {element.descriptionList.map(item => (
            <Styles.DescriptionListItem key={item.id}>
              {item.icon}
              {item.text}
            </Styles.DescriptionListItem>
          ))}
        </Styles.DescriptionList>

        <ButtonWrapper>
          <GradientButton
            testId="cta"
            label={element.cta.label}
            variant="quaternary"
            size="lg"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </ButtonWrapper>
      </DivText>
    </DivContents>
  );
};

export default AiAgentsHighlight;
